export const routes = {
  COMPLETED: "/completed",
  DASHBOARD: "/dashboard",
  QUESTIONNAIRE: "/questionnaire",
};
